import { ServiceBase } from "services/base-service";

export interface BuildInfo {
  version: string;
  commit: string;
  buildTime: string;
}

export interface BackendVersionResponse extends BuildInfo {
  environment: string;
}

const UNKNOWN = "unknown";

export const frontendBuildInfo: BuildInfo =
  typeof APP_BUILD_INFO !== "undefined" ? APP_BUILD_INFO : { version: UNKNOWN, commit: UNKNOWN, buildTime: UNKNOWN };

class VersionService extends ServiceBase {
  getBackendVersion = async (abortController?: AbortController): Promise<BackendVersionResponse> => {
    const response = await this.sendGet("/version", abortController);

    return response;
  };
}

const versionService = new VersionService();

export { versionService };
